import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import api from '../..'
import { applyFilters } from '../../../helpers/filterData.helper'

export type SelectedCollaboratorsSendEmailAPI = {
  add: string[]
  discard: string[]
  all: boolean
}

export interface SendEmailAPIParams {
  selectedCollaborators: SelectedCollaboratorsSendEmailAPI
  courseId: number
  subject: string
  content: string
  filterData?: IFilterData
  search?: string
}

export const sendEmailAPI = ({
  selectedCollaborators,
  courseId,
  subject,
  content,
  filterData,
  search,
}: SendEmailAPIParams) => {
  const g = applyFilters(filterData)
  return api.post(`administration/monitoring/${courseId}/notification`, {
    selectedCollaborators,
    subject,
    content,
    search,
    q: {
      g,
    },
  })
}
